import { format, parseJSON } from 'date-fns'

import { Roles } from 'constants/EntityConstants'
import { DATE_FORMAT } from 'constants/index'
import { CreateUpdateUserDtoInput, GetUserDetailsQuery } from 'generated/graphql'
import { TUserForm } from 'types'

export interface ILegalDocumentAdherence {
  isApplicable: boolean
  acceptedAt?: string | null
  version?: string | null
}

export const formatAdherence = (adherence?: ILegalDocumentAdherence | null): string => {
  if (!adherence || !adherence.isApplicable) return 'N/A'
  if (!adherence.acceptedAt || !adherence.version) return '—'
  return `${format(parseJSON(adherence.acceptedAt), DATE_FORMAT)} (${adherence.version})`
}

export const normalizeUserForm = (
  user: NonNullable<GetUserDetailsQuery['userDetails']>,
): TUserForm => {
  const companyDetails = user.companyDetails
    ? {
        companyName: user.companyDetails.companyName,
        customerId: user.companyDetails.customerId,
        contactId: user.companyDetails.contactId,
      }
    : undefined

  return {
    username: user.userName,
    role: user.role,
    firstName: user.firstName,
    lastName: user.lastName,
    email: user.email,
    city: user.city ?? '',
    postcode: user.postcode ?? '',
    dob: user.dob,
    countryId: user.countryId,
    phoneNumber: user.phoneNumber,
    driverId: user.driverId,
    companyDetails,
  }
}

export const normalizeUserDto = (formData: TUserForm): CreateUpdateUserDtoInput => {
  const companyDetails =
    formData.role === Roles.customer && formData.companyDetails
      ? {
          companyName: formData.companyDetails.companyName,
          customerId: formData.companyDetails.customerId,
          contactId: formData.companyDetails?.contactId
            ? Number(formData.companyDetails?.contactId)
            : undefined,
        }
      : undefined

  return {
    username: formData.username,
    password: formData.password,
    role: formData.role,
    firstName: formData.firstName,
    lastName: formData.lastName,
    email: formData.email,
    city: formData.city,
    postcode: formData.postcode,
    dob: formData.dob,
    countryId: String(formData.countryId),
    phoneNumber: formData.phoneNumber,
    companyDetails,
  }
}

export const formatOnboardingStatus = (isOnboardingCompleted?: boolean | null): string => {
  if (isOnboardingCompleted === undefined || isOnboardingCompleted === null) return 'N/A'
  return isOnboardingCompleted ? 'Yes' : 'No'
}
